/** The Set variable element: sets or adds to one of the workflow's declared variables. */
import { MetadataEntityFieldType } from '../../../metadata/entity/decorators/model/metadata.entity.field.types';
import { WorkflowStepType, WorkflowVariableOp } from '../workflow.definition';
import { WorkflowElement, WorkflowFamily, WorkflowFieldOptionSource, WorkflowSideEffect } from '../workflow.element';

/** Sets a declared variable to a value, or adds a number to a number variable; the validator checks the value's type. */
export const SET_VARIABLE_ELEMENT: WorkflowElement = {
    type: WorkflowStepType.SetVariable,
    family: WorkflowFamily.Flow,
    sideEffect: WorkflowSideEffect.None,
    title: 'Set variable',
    icon: 'fa-square-root-variable',
    fields: [
        {
            bind: 'variable',
            required: true,
            bindable: false,
            optionSource: WorkflowFieldOptionSource.Variables,
            metadata: {
                displayName: 'Variable',
                type: MetadataEntityFieldType.Enum,
            },
        },
        {
            bind: 'op',
            required: true,
            bindable: false,
            metadata: {
                displayName: 'Operation',
                type: MetadataEntityFieldType.Enum,
                options: [
                    { value: WorkflowVariableOp.Set, label: 'Set to' },
                    { value: WorkflowVariableOp.Add, label: 'Add' },
                ],
            },
        },
        {
            bind: 'value',
            required: true,
            bindable: true,
            typeOf: 'variable',
            metadata: {
                displayName: 'Value',
                type: MetadataEntityFieldType.String,
            },
        },
    ],
    outputs: [],
};
